import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['backdrop', 'iframe', 'title', 'downloadBtn', 'placeholder']

  open(event) {
    event.preventDefault()

    const el = event.currentTarget
    const url = el.dataset.previewUrl
    const title = el.dataset.previewTitle || 'Tax Return'
    const downloadUrl = el.dataset.downloadUrl || url

    this.titleTarget.textContent = title

    if (downloadUrl) {
      this.downloadBtnTarget.href = downloadUrl
      this.downloadBtnTarget.classList.remove('d-none')
    } else {
      this.downloadBtnTarget.classList.add('d-none')
    }

    if (url) {
      this.iframeTarget.classList.remove('d-none')
      this.placeholderTarget.classList.add('d-none')
      requestAnimationFrame(() => {
        this.iframeTarget.src = url
      })
    } else {
      this.iframeTarget.classList.add('d-none')
      this.placeholderTarget.classList.remove('d-none')
    }

    this.backdropTarget.classList.remove('d-none')
    document.body.style.overflow = 'hidden'
  }

  close() {
    this.backdropTarget.classList.add('d-none')
    this.iframeTarget.src = 'about:blank'
    document.body.style.overflow = ''
  }

  backdropClick(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }
}
